/*!
 * Copyright (C) Microsoft Corporation. All rights reserved.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { CommandName } from '../FormulaEditor.types';
var RepairHoverProvider = /** @class */ (function () {
    function RepairHoverProvider(monacoParam, lang, editor, options) {
        this._defaultOptions = {
            styles: {
                deletedBackgroundColorHex: '#FFCCCB',
                addedBackgroundColorHex: '#90EE90',
            },
            strings: {
                suggestedFixes: 'Suggested fixes',
                applyFix: '🔧 Apply Fix',
                applyFixToolTip: 'Corrects your formula with suggested fix',
            },
            notifyFixApplied: false,
        };
        this._monaco = monacoParam;
        this._languageClient = lang;
        this._editor = editor;
        options = options || {};
        this._options = __assign(__assign({}, this._defaultOptions), options);
        // register command for executing code changes
        this._monaco.editor.registerCommand('repair.applyQuickFixFromHover', this.runFixFromHoverSelection.bind(this));
    }
    RepairHoverProvider.createMarkdownLink = function (label, cmd, edits, tooltip, action) {
        // Create a base64 encoded representation of TextEdit object to avoid any parsing or stripping issues when
        // parsed by markdown.
        var input = { edits: edits, action: action };
        var base64args = { base64: Buffer.from(JSON.stringify(input)).toString('base64') };
        var encodedArgs = encodeURIComponent(JSON.stringify(base64args));
        return "[" + label + "](command:" + cmd + "?" + encodedArgs + " \"" + tooltip + "\")";
    };
    RepairHoverProvider.prototype.runFixFromHoverSelection = function (accessor, encodedArgs) {
        // Recover original TextEdit object from base64 encoded argument
        var _a = JSON.parse(atob(encodedArgs.base64)), edits = _a.edits, action = _a.action;
        var id = { major: 1, minor: 1 };
        var text = edits.newText;
        var range = {
            startLineNumber: edits.range.start.line,
            startColumn: edits.range.start.character,
            endLineNumber: edits.range.end.line,
            endColumn: edits.range.end.character,
        };
        var op = { identifier: id, range: range, text: text, forceMoveMarkers: true };
        // Apply Text Edit
        if (this._editor.executeEdits(null, [op])) {
            this._languageClient.notifyCommandExecutedAsync(CommandName.CodeActionApplied, action);
        }
    };
    RepairHoverProvider.prototype.createQuickFixLink = function (edits, action) {
        return RepairHoverProvider.createMarkdownLink(this._options.strings.applyFix, 'repair.applyQuickFixFromHover', edits, this._options.strings.applyFixToolTip, action);
    };
    RepairHoverProvider.prototype._format = function (text, textRange) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var codeActionResult, changes, _b, _c, action, _d, _e, change, strValue;
            var e_1, _f, e_2, _g;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0: return [4 /*yield*/, ((_a = this._languageClient) === null || _a === void 0 ? void 0 : _a.requestCodeActionAsync(text, {
                            start: { line: textRange.startLineNumber, character: textRange.startColumn },
                            end: { line: textRange.endLineNumber, character: textRange.endColumn },
                        }, 'quickfix'))];
                    case 1:
                        codeActionResult = _h.sent();
                        changes = [];
                        if (codeActionResult) {
                            try {
                                for (_b = __values(codeActionResult === null || codeActionResult === void 0 ? void 0 : codeActionResult.actions), _c = _b.next(); !_c.done; _c = _b.next()) {
                                    action = _c.value;
                                    try {
                                        for (_d = (e_2 = void 0, __values(action.edit.changes[codeActionResult.uri])), _e = _d.next(); !_e.done; _e = _d.next()) {
                                            change = _e.value;
                                            strValue = "<span style=\"background-color:" + this._options.styles.deletedBackgroundColorHex + ";\">" +
                                                text +
                                                '</span>' +
                                                '<span>' +
                                                '&nbsp;=>&nbsp;' +
                                                ("</span><span style=\"background-color:" + this._options.styles.addedBackgroundColorHex + ";\">") +
                                                change.newText +
                                                '</span>' +
                                                '\n\n' +
                                                (this.createQuickFixLink(change, __assign(__assign({}, action), { id: codeActionResult.id })) + "\n\n");
                                            changes.push({ isTrusted: true, supportsHtml: true, value: strValue });
                                        }
                                    }
                                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                                    finally {
                                        try {
                                            if (_e && !_e.done && (_g = _d.return)) _g.call(_d);
                                        }
                                        finally { if (e_2) throw e_2.error; }
                                    }
                                }
                            }
                            catch (e_1_1) { e_1 = { error: e_1_1 }; }
                            finally {
                                try {
                                    if (_c && !_c.done && (_f = _b.return)) _f.call(_b);
                                }
                                finally { if (e_1) throw e_1.error; }
                            }
                        }
                        return [2 /*return*/, {
                                contents: __spread([{ value: "**" + this._options.strings.suggestedFixes + "**\n" }], changes),
                            }];
                }
            });
        });
    };
    RepairHoverProvider.prototype.provideHover = function (model, position, token) {
        if (this._monaco.editor.getModelMarkers({}).length > 0) {
            var textRange = model.getFullModelRange();
            var text = model.getValue();
            return this._format(text, textRange);
        }
        else {
            return { contents: [{ value: '' }] };
        }
    };
    return RepairHoverProvider;
}());
export { RepairHoverProvider };
//# sourceMappingURL=RepairHoverProvider.js.map